import { BaseService, Service } from "/@/cool";

@Service("shootOrdersxx")
class ShootOrders extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["privacyChecking"] = prefix + "privacyChecking";
		this.permission["shakeCheck"] = prefix + "shakeCheck";
		this.permission["shootPreview"] = prefix + "shootPreview";
		this.permission["shootPreviewCartoon"] = prefix + "shootPreviewCartoon";
		this.permission["saveModelInfo"] = prefix + "saveModelInfo";
		this.permission["checkViewAllType"] = prefix + "checkViewAllType";
		this.permission["orderAddress"] = prefix + "orderAddress";
		this.permission["all"] = prefix + "all";
		this.permission["view"] = prefix + "view";
		this.permission["preCalcHeight"] = prefix + "preCalcHeight";
	}

	// 获取订单数据
	view(params: any) {
		return this.request({
			url: "/view",
			method: "GET",
			params
		});
	}
	// 获取订单地址
	orderAddress(params: any) {
		return this.request({
			url: "/orderAddress",
			method: "GET",
			params
		});
	}
	// 保存模型信息
	saveModelInfo(params: any) {
		return this.request({
			url: "/saveModelInfo",
			method: "POST",
			params
		});
	}

	takephotoImages(params: any) {
		return this.request({
			url: "/takephotoImages",
			method: "POST",
			data: { ...params }
		});
	}

	// 审核照片
	shakeCheck(data: any) {
		return this.request({
			url: "/shakeCheck",
			method: "POST",
			data
		});
	}

	// 隐私
	privacyChecking(data: {}) {
		return this.request({
			url: "/privacyChecking",
			method: "POST",
			data: {
				...data
			}
		});
	}

	shootPreview(data: any) {
		return this.request({
			url: "/shootPreview",
			method: "POST",
			data
		});
	}

	shootPreviewCartoon(data: any) {
		return this.request({
			url: "/shootPreviewCartoon",
			method: "POST",
			data
		});
	}

	checkViewAllType(data: any) {
		return this.request({
			url: "/checkViewAllType",
			method: "POST",
			data
		});
	}
	all(data: any) {
		return this.request({
			url: "/all",
			method: "POST",
			data
		});
	}

	// 身高计算
	preCalcHeight(data: any) {
		return this.request({
			url: "/preCalcHeight",
			method: "POST",
			data
		});
	}
}
export default ShootOrders;
